/**
 * iter_226 · Phase 22 — Singles Store · Public browse tab
 * (rendered inside BeatsMarketplacePage tab shell)
 */
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import { optimizeImage } from "@/lib/mediaUrls";

const fmtUsd = (n) => `$${Number(n || 0).toFixed(2)}`;

const SinglesStorePage = () => {
  const [data, setData] = useState(null);
  const [err, setErr] = useState("");

  useEffect(() => {
    (async () => {
      try {
        const r = await api.get("/singles?limit=24");
        setData(r.data);
      } catch (e) {
        setErr(e?.response?.data?.detail || "Singles Store is not yet available.");
      }
    })();
  }, []);

  if (err) {
    return (
      <div className="rounded-xl border border-white/10 bg-white/[0.03] p-6 text-center" data-testid="singles-store-disabled">
        <p className="text-lg font-black text-white mb-1">Singles Store — Coming Soon</p>
        <p className="text-xs text-gray-400">{err}</p>
      </div>
    );
  }
  if (!data) return <div className="text-xs text-gray-500 py-6">Loading…</div>;

  return (
    <div className="space-y-5" data-testid="singles-store">
      <div className="rounded-xl border border-emerald-400/30 bg-gradient-to-br from-emerald-500/10 via-cyan-500/10 to-purple-500/10 p-4">
        <p className="text-[10px] uppercase tracking-widest font-black text-emerald-200">Singles Store</p>
        <h2 className="text-2xl font-black text-white mt-1">{data.hero_line}</h2>
        <p className="text-[11px] text-gray-400 mt-1">Personal-use downloads sold directly by RGM Studio artists.</p>
      </div>
      {(data.items || []).length === 0 && (
        <p className="text-xs text-gray-500 py-8 text-center" data-testid="singles-empty">
          No singles are for sale yet. Check back soon.
        </p>
      )}
      <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-3">
        {(data.items || []).map((s) => (
          <Link
            key={s.listing_id}
            to={`/singles/${s.listing_id}`}
            className="rounded-xl overflow-hidden border border-white/10 bg-black/40 hover:border-emerald-400/40 transition"
            data-testid={`singles-card-${s.listing_id}`}
          >
            <div className="aspect-square bg-white/5">
              {s.cover_url && <img src={optimizeImage(s.cover_url, 'card')} alt="" className="w-full h-full object-cover" />}
            </div>
            <div className="p-2">
              <p className="text-xs font-bold text-white truncate">{s.title}</p>
              <p className="text-[10px] text-gray-400 truncate">{s.primary_artist_name}</p>
              <p className="text-[11px] text-emerald-300 font-black mt-1">{fmtUsd(s.price_usd)}</p>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
};

export default SinglesStorePage;
